import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import * as serviceWorker from './serviceWorker';
import Router from './router';
import configureStore from './store';
import './index.css';
import ErrorBoundary from './utils/ErrorBoundary';
import { SnackbarProvider } from "notistack";
import Theme from './resources/theme';
import { ThemeProvider } from 'react-jss';
import clevertap from 'clevertap-web-sdk';


const store = configureStore();

const root = ReactDOM.createRoot(
  document.getElementById("root")
)

// clevertap.privacy.push({ optOut: true })
// clevertap.privacy.push({ useIP: true })
clevertap.init("44K-Z86-456Z",);
// clevertap.setLogLevel(3)
// clevertap.spa = true

root.render(
  <Provider store={store}>
    <ThemeProvider theme={Theme}>
      <SnackbarProvider
        maxSnack={1}
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        <ErrorBoundary>
          <Router />
        </ErrorBoundary>
      </SnackbarProvider>
    </ThemeProvider>
  </Provider>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
